import React, { useState, useEffect } from "react";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import StatusPledge from "../StatusPledge";
import Pagination from "../../../partials/content/Pagination";

function AllPledge() {
  const [pledges, setPledges] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [pledgeIDSearchFilter, setPledgeIDSearchFilter] = useState();

  useEffect(() => {
    getAllPledge();
  }, [currentPage, countItemPerPage, pledgeIDSearchFilter]);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getAllPledge = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allPledge = await sendRequestGetAllPledge(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (allPledge === false) {
      return;
    }

    setPledges(allPledge.pledges);
    setCountPage(allPledge.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (pledgeIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${pledgeIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetAllPledge = async (searchFilterQuery) => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/pledges/manage?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const generatePledge = () => {
    return (
      <>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره بیعانه</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setPledgeIDSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره بیعانه</td>
                <td>شماره کمپین</td>
                <td>مبلغ</td>
                <td>وضعیت</td>
                <td>تاریخ درج</td>
                <td>تاریخ بازگشت</td>
              </tr>
            </thead>
            <tbody>
              {pledges.map((pledges, index) => {
                return (
                  <tr key={pledges.ple_id}>
                    <td>{index + 1}</td>
                    <td>{pledges.ple_id}</td>
                    <td>{pledges.ple_campaign_id}</td>
                    <td className="number-finance">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(pledges.ple_amount)
                      )}
                    </td>
                    <td>
                      <span
                        className={`badge 
                         ${
                           pledges.ple_status ===
                           StatusPledge.statusPledge.BLOCK
                             ? "badge-danger"
                             : ""
                         } 
                         ${
                           pledges.ple_status === StatusPledge.statusPledge.GET
                             ? "badge-warning"
                             : ""
                         } 
                         ${
                           pledges.ple_status === StatusPledge.statusPledge.GIVE
                             ? "badge-success"
                             : ""
                         } 
                      `}
                      >
                        {StatusPledge.statusPledgeString()[pledges.ple_status]}
                      </span>
                    </td>
                    <td>
                      {helperNumbers.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          pledges.ple_created_at
                        )
                      )}
                    </td>
                    <td>
                      {pledges.ple_returned_at !== null
                        ? helperNumbers.toPersianNum(
                            helperTime.convertGregorianToJalali(
                              pledges.ple_returned_at
                            )
                          )
                        : ""}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="manage-all-pledge" />
      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">لیست بیعانه</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              {pledges.length == 0 && pledgeIDSearchFilter == null ? (
                <></>
              ) : (
                generatePledge()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllPledge;
